import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Fuel } from 'lucide-react';
function PrizeWheel() {
  const segments = 8;
  const colors = ['#3b9eff', '#3bf65d'];
  return <span className="relative inline-flex w-9 h-9 items-center justify-center" data-id="element-21">
      <svg viewBox="0 0 40 40" className="w-9 h-9 animate-[spin_5s_linear_infinite]" data-id="element-22">
        {Array.from({
        length: segments
      }).map((_, i) => {
        const a0 = i / segments * 2 * Math.PI - Math.PI / 2;
        const a1 = (i + 1) / segments * 2 * Math.PI - Math.PI / 2;
        const r = 18;
        const x0 = 20 + r * Math.cos(a0);
        const y0 = 20 + r * Math.sin(a0);
        const x1 = 20 + r * Math.cos(a1);
        const y1 = 20 + r * Math.sin(a1);
        return <path key={i} d={`M20 20 L ${x0} ${y0} A ${r} ${r} 0 0 1 ${x1} ${y1} Z`} fill={colors[i % colors.length]} opacity={i % colors.length === 0 ? 0.95 : 0.75} data-id="element-23" />;
      })}
        <circle cx="20" cy="20" r="18" fill="none" stroke="#0f172a" strokeWidth="2" data-id="element-24" />
        <circle cx="20" cy="20" r="4" fill="#0f172a" data-id="element-25" />
      </svg>
      {/* Static pointer */}
      <span className="absolute -top-0.5 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[4px] border-r-[4px] border-t-[6px] border-l-transparent border-r-transparent border-t-white" data-id="element-26" />
    </span>;
}
export function Slide01Title() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 24
      }
    }
  };
  return <div className="w-full min-h-full flex flex-col items-center justify-center p-[clamp(1.5rem,5vw,4rem)] text-center" data-id="element-27">
      <motion.div variants={container} initial="hidden" animate="show" className="max-w-5xl flex flex-col items-center" data-id="element-28">
        <motion.div variants={item} className="mb-6 md:mb-8" data-id="element-29">
          <div className="relative w-[clamp(14rem,42vw,22rem)] aspect-[2.4/1]" data-id="element-30">
            {/* Infinity track + tracer */}
            <svg viewBox="0 0 240 100" className="absolute inset-0 w-full h-full overflow-visible" aria-hidden="true" data-id="element-31">
              {/* Faint base track (also the motion path) */}
              <path id="infinityPath" d="M120 50 C 84 14, 18 14, 18 50 C 18 86, 84 86, 120 50 C 156 14, 222 14, 222 50 C 222 86, 156 86, 120 50 Z" fill="none" stroke="#1e293b" strokeWidth="2.5" data-id="element-32" />
              {/* Subtle accent tint on the track */}
              <path d="M120 50 C 84 14, 18 14, 18 50 C 18 86, 84 86, 120 50 C 156 14, 222 14, 222 50 C 222 86, 156 86, 120 50 Z" fill="none" stroke="#3bf65d" strokeWidth="2.5" strokeLinecap="round" opacity="0.12" data-id="element-33" />
              {/* Glowing tracer dot orbiting the figure-eight forever */}
              <circle r="3.5" fill="#3bf65d" style={{
              filter: 'drop-shadow(0 0 6px rgba(59,246,93,0.9))'
            }} data-id="element-34">
                <animateMotion dur="7s" repeatCount="indefinite" rotate="auto" data-id="element-35">
                  <mpath href="#infinityPath" data-id="element-36" />
                </animateMotion>
              </circle>
              {/* Faint trailing dot for a subtle comet feel */}
              <circle r="2" fill="#3bf65d" opacity="0.4" data-id="element-37">
                <animateMotion dur="7s" begin="-0.18s" repeatCount="indefinite" rotate="auto" data-id="element-38">
                  <mpath href="#infinityPath" data-id="element-39" />
                </animateMotion>
              </circle>
            </svg>

            {/* Left loop: Gas pump */}
            <div className="absolute top-1/2 left-[25%] -translate-x-1/2 -translate-y-1/2 w-14 h-14 rounded-2xl bg-surface flex items-center justify-center border border-surface-hover shadow-[0_0_30px_rgba(59,246,93,0.2)]" data-id="element-40">
              <Fuel className="w-7 h-7 text-accent" data-id="element-41" />
            </div>
            {/* Right loop: Play wheel */}
            <div className="absolute top-1/2 left-[75%] -translate-x-1/2 -translate-y-1/2 w-14 h-14 rounded-2xl bg-surface flex items-center justify-center border border-surface-hover shadow-[0_0_30px_rgba(59,158,255,0.25)]" data-id="element-42">
              <PrizeWheel data-id="element-43" />
            </div>
          </div>
        </motion.div>

        <motion.h1 variants={item} className="text-[clamp(3rem,8vw,7rem)] font-black leading-[0.9] tracking-tighter text-balance mb-4 md:mb-6" data-id="element-44">
          FUEL UP <br data-id="element-45" />
          <span className="inline-block px-[0.12em] pb-[0.12em] leading-[1.05] text-transparent bg-clip-text bg-gradient-to-r from-accent via-emerald-400 to-accent-secondary text-glow" data-id="element-46">
            & PLAY
          </span>
        </motion.h1>

        <motion.p variants={item} className="text-[clamp(1.125rem,2.5vw,2rem)] text-muted font-medium max-w-3xl text-balance mb-8 md:mb-12" data-id="element-47">
          Convert idle time at the pump into leads and loyal customers.
        </motion.p>

        <motion.div variants={item} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-surface border border-surface-hover text-sm font-bold tracking-widest text-accent uppercase" data-id="element-48">
          Freeplay Contests to Build Loyalty
        </motion.div>
      </motion.div>
    </div>;
}